/**
 * Normalize list API pagination for DataTable server-side mode.
 * DataTable needs totalPages (not undefined) and optional currentPage sync.
 * APIs may return pages, totalPages, hasNextPage, hasPrevPage, etc.
 */
export function normalizeListPagination(apiResponse, defaults = {}) {
  const p = apiResponse?.pagination;
  const rows = apiResponse?.data ?? [];
  const base = {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
    hasNext: false,
    hasPrev: false,
    ...defaults,
  };

  if (!p) {
    return {
      ...base,
      total: rows.length,
      totalPages: rows.length > 0 ? 1 : 0,
    };
  }

  const totalPages = p.pages ?? p.totalPages ?? 0;

  return {
    page: p.page ?? base.page,
    limit: p.limit ?? base.limit,
    total: p.total ?? 0,
    totalPages,
    hasNext: p.hasNextPage ?? p.hasNext ?? false,
    hasPrev: p.hasPrevPage ?? p.hasPrev ?? (p.page ?? 1) > 1,
  };
}
